var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHorizontalFullBrand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 592.96 134.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 65.94,
    y1: -1.68,
    x2: 69.12,
    y2: 174.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#2328eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2342eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2360eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#2373eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#237aeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#2391eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#23caeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#23cceb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 62.87,
    y1: 89.53,
    x2: 77.09,
    y2: -45.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2328eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#232aeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#2332eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2340eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2353eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#236beb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#237aeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#23cceb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 17.78,
    y1: 78.27,
    x2: 16.85,
    y2: 26.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2328eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23cceb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 52.11,
    y1: 78.66,
    x2: 51.19,
    y2: 26.44,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 86.14,
    y1: 78.99,
    x2: 85.21,
    y2: 26.78,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 120.03,
    y1: 78.84,
    x2: 119.1,
    y2: 26.63,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.43,42.52V83.94h-10.1v-3q-3,3.52-8.88,3.52a15,15,0,0,1-7.53-1.93A13.89,13.89,0,0,1,395.53,77a16.77,16.77,0,0,1-2-8.26,16.64,16.64,0,0,1,2-8.24,13.83,13.83,0,0,1,5.39-5.44,15.26,15.26,0,0,1,7.53-1.9c3.61,0,6.4,1,8.37,3.13V42.52ZM415.21,74.09A7.55,7.55,0,0,0,417,68.76a7.43,7.43,0,0,0-1.75-5.25,6,6,0,0,0-4.55-1.9,6,6,0,0,0-4.58,1.9,7.36,7.36,0,0,0-1.79,5.25,7.55,7.55,0,0,0,1.79,5.33A6,6,0,0,0,410.69,76,5.91,5.91,0,0,0,415.21,74.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.47,53.18h10.6V83.94h-10.6Zm10.6-8.48a5.39,5.39,0,1,1-5.38-5.38A5.39,5.39,0,0,1,441.07,44.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.42,53.3V78.41q0,8.43-4.58,12.64t-13.17,4.22a33.45,33.45,0,0,1-8.37-1,19.84,19.84,0,0,1-6.64-3l3.85-7.43a13.35,13.35,0,0,0,4.66,2.37,18.76,18.76,0,0,0,5.55.87q4.18,0,6.14-1.84a7.18,7.18,0,0,0,2-5.47v-1q-3.07,3.57-9,3.58a15.49,15.49,0,0,1-7.42-1.82A13.85,13.85,0,0,1,446,75.43a15.56,15.56,0,0,1,0-15.3A13.85,13.85,0,0,1,451.41,55a15.49,15.49,0,0,1,7.42-1.82q6.48,0,9.49,4.19V53.3ZM466.06,72.22a6.28,6.28,0,0,0,0-8.91,6.74,6.74,0,0,0-4.75-1.7,6.85,6.85,0,0,0-4.77,1.7,6.21,6.21,0,0,0,0,8.91,7.33,7.33,0,0,0,9.46,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.55,53.18h10.61V83.94H481.55Zm10.69-8.42a5.39,5.39,0,1,1-5.38-5.39A5.38,5.38,0,0,1,492.24,44.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.92,83.78a29.2,29.2,0,0,1-5.25.66q-5.91,0-9.09-2.9c-2.13-1.94-3.18-4.82-3.18-8.65V62.73H495V54.8h4.41V46.93H510V54.8h6.92v7.93H510V72.78a3.57,3.57,0,0,0,.86,2.53,3,3,0,0,0,2.32.92,7.4,7.4,0,0,0,3.74-1.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.5,56.62q4,3.42,4,10.52v16.8h-9.88V80q-2.3,4.41-8.93,4.41a14,14,0,0,1-6.08-1.23,8.92,8.92,0,0,1-3.88-3.32,8.74,8.74,0,0,1-1.31-4.77,7.72,7.72,0,0,1,3.29-6.67q3.29-2.37,10.16-2.37h6q-.27-4.8-6.41-4.8A14.84,14.84,0,0,0,527,62a11.81,11.81,0,0,0-3.8,1.93l-3.57-7.2a19.54,19.54,0,0,1,6.11-2.59,28.8,28.8,0,0,1,7.23-.93Q540.53,53.18,544.5,56.62Zm-8.66,20.23a5,5,0,0,0,2-2.62V71.6h-4.57c-3.09,0-4.63,1-4.63,3.07a2.68,2.68,0,0,0,1.06,2.23,4.53,4.53,0,0,0,2.9.84A5.86,5.86,0,0,0,535.84,76.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.09,53.3h10.6V83.94h-10.6Zm10.68-8.54a5.39,5.39,0,1,1-5.38-5.39A5.38,5.38,0,0,1,561.77,44.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.52,83.58a19.57,19.57,0,0,1-5.92-2.27l3.18-7.25a18.48,18.48,0,0,0,4.92,2,22,22,0,0,0,5.63.75,9.14,9.14,0,0,0,3.66-.53,1.68,1.68,0,0,0,1.09-1.54c0-.67-.44-1.14-1.31-1.42a27.08,27.08,0,0,0-4.16-.81,41.8,41.8,0,0,1-6.17-1.17,9.53,9.53,0,0,1-4.38-2.68,7.64,7.64,0,0,1-1.84-5.47A8.22,8.22,0,0,1,567,58.07a11.35,11.35,0,0,1,5-3.57,21.48,21.48,0,0,1,8-1.32,32.59,32.59,0,0,1,6.53.67,19,19,0,0,1,5.42,1.9L588.71,63a17.58,17.58,0,0,0-8.7-2.23,8.72,8.72,0,0,0-3.69.58,1.77,1.77,0,0,0-1.17,1.54c0,.71.43,1.2,1.28,1.48a28.49,28.49,0,0,0,4.25.86,48.72,48.72,0,0,1,6.19,1.29,9.46,9.46,0,0,1,4.27,2.65A7.54,7.54,0,0,1,593,74.5a8.22,8.22,0,0,1-1.73,5.11,11.34,11.34,0,0,1-5.11,3.55A23,23,0,0,1,578,84.44,33,33,0,0,1,570.52,83.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.73,53.79V80.11q0,7.62-3.73,11.3t-11.25,3.67a25.06,25.06,0,0,1-7.89-1.22,16.37,16.37,0,0,1-6.06-3.39l2-3.08a15.2,15.2,0,0,0,5.27,3,19.44,19.44,0,0,0,6.52,1.09c3.8,0,6.59-.89,8.37-2.65s2.68-4.51,2.68-8.23V76.8a12.2,12.2,0,0,1-4.93,4.33A15.19,15.19,0,0,1,182,82.61a16,16,0,0,1-7.66-1.85,13.62,13.62,0,0,1-5.41-5.18A14.58,14.58,0,0,1,167,68a14.42,14.42,0,0,1,2-7.52,13.69,13.69,0,0,1,5.38-5.13A16.17,16.17,0,0,1,182,53.56a15.24,15.24,0,0,1,6.89,1.54,12.49,12.49,0,0,1,5,4.44V53.79Zm-9.45,23.84a10.13,10.13,0,0,0,4.07-3.9A11.16,11.16,0,0,0,193.8,68a11,11,0,0,0-1.45-5.67,10.24,10.24,0,0,0-4-3.87,13.13,13.13,0,0,0-11.74,0,9.91,9.91,0,0,0-4,3.87,11.93,11.93,0,0,0,0,11.4,10.11,10.11,0,0,0,4,3.9A12.14,12.14,0,0,0,182.41,79,12.29,12.29,0,0,0,188.28,77.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.16,70H205.1a10.7,10.7,0,0,0,3.59,7.55,11.9,11.9,0,0,0,8.2,2.88,13,13,0,0,0,5.13-1,11.2,11.2,0,0,0,4-2.93l2.28,2.62a12.83,12.83,0,0,1-5,3.64,18,18,0,0,1-14.76-.71,14.16,14.16,0,0,1-5.55-5.44,15.51,15.51,0,0,1-2-7.86,16.09,16.09,0,0,1,1.9-7.86,13.8,13.8,0,0,1,5.25-5.41,15.37,15.37,0,0,1,14.95,0,13.68,13.68,0,0,1,5.18,5.38,16.26,16.26,0,0,1,1.88,7.89ZM208.43,59.8A10.88,10.88,0,0,0,205.1,67h21.25A10.84,10.84,0,0,0,223,59.8a11,11,0,0,0-14.58,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.1,55.1a14.5,14.5,0,0,1,7-1.54v3.93l-1-.05a9.54,9.54,0,0,0-7.4,2.9Q237,63.25,237,68.48V83.75h-4v-30h3.87v5.87A9.79,9.79,0,0,1,241.1,55.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.77,70H253.71a10.73,10.73,0,0,0,3.59,7.55,11.9,11.9,0,0,0,8.2,2.88,13,13,0,0,0,5.13-1,11.2,11.2,0,0,0,4-2.93L277,79.14a12.83,12.83,0,0,1-5,3.64A16.81,16.81,0,0,1,265.39,84a16.6,16.6,0,0,1-8.17-2,14.12,14.12,0,0,1-5.56-5.44,15.51,15.51,0,0,1-2-7.86,16,16,0,0,1,1.91-7.86,13.71,13.71,0,0,1,5.24-5.41,15.37,15.37,0,0,1,14.95,0A13.68,13.68,0,0,1,277,60.88a16.26,16.26,0,0,1,1.88,7.89ZM257,59.8a10.88,10.88,0,0,0-3.33,7.2H275a10.84,10.84,0,0,0-3.34-7.2,11,11,0,0,0-14.58,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.14,56.84q3.33,3.27,3.33,9.54V83.75h-4v-17q0-4.68-2.34-7.12a8.75,8.75,0,0,0-6.66-2.45,10.28,10.28,0,0,0-7.67,2.87A10.91,10.91,0,0,0,286,68V83.75H281.9v-30h3.88v5.52a11.17,11.17,0,0,1,4.58-4.24,14.73,14.73,0,0,1,6.81-1.51A12.21,12.21,0,0,1,306.14,56.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.5,81.93a7.65,7.65,0,0,1-2.81,1.56,11.4,11.4,0,0,1-3.51.54,7.93,7.93,0,0,1-8.77-8.71V57.21h-5.35V53.79h5.35V47.24h4v6.55h9.11v3.42h-9.11V75.09a5.65,5.65,0,0,0,1.33,4.07,5.11,5.11,0,0,0,3.85,1.4,7.36,7.36,0,0,0,2.42-.4,5.8,5.8,0,0,0,2-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.2,70H337.14a10.69,10.69,0,0,0,3.58,7.55,11.92,11.92,0,0,0,8.21,2.88,13,13,0,0,0,5.12-1,11.15,11.15,0,0,0,4.05-2.93l2.27,2.62a12.69,12.69,0,0,1-5,3.64,18,18,0,0,1-14.75-.71,14.1,14.1,0,0,1-5.55-5.44,15.52,15.52,0,0,1-2-7.86A16.1,16.1,0,0,1,335,60.91a13.78,13.78,0,0,1,5.24-5.41,14.64,14.64,0,0,1,7.49-1.94,14.48,14.48,0,0,1,7.46,1.94,13.68,13.68,0,0,1,5.18,5.38,16.15,16.15,0,0,1,1.88,7.89ZM340.47,59.8a10.79,10.79,0,0,0-3.33,7.2h21.24a10.83,10.83,0,0,0-3.33-7.2A10.28,10.28,0,0,0,347.73,57,10.17,10.17,0,0,0,340.47,59.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.64,83a14.83,14.83,0,0,1-5.21-2.65l1.82-3.19A15.11,15.11,0,0,0,372,79.56a18.67,18.67,0,0,0,5.92.94c2.74,0,4.76-.42,6.07-1.28a4.07,4.07,0,0,0,2-3.61,3.27,3.27,0,0,0-1.09-2.6,7.22,7.22,0,0,0-2.73-1.42,38.46,38.46,0,0,0-4.39-.94,49.76,49.76,0,0,1-5.86-1.4,8.5,8.5,0,0,1-3.79-2.42,6.69,6.69,0,0,1-1.57-4.72A7.44,7.44,0,0,1,369.64,56q3.14-2.39,8.72-2.39a22.74,22.74,0,0,1,5.81.77,16,16,0,0,1,4.78,2l-1.76,3.25A15.11,15.11,0,0,0,378.36,57a10.26,10.26,0,0,0-5.84,1.36,4.18,4.18,0,0,0-2,3.59,3.56,3.56,0,0,0,1.11,2.74,6.82,6.82,0,0,0,2.76,1.5,42,42,0,0,0,4.56,1,52.21,52.21,0,0,1,5.75,1.37,8.31,8.31,0,0,1,3.7,2.34A6.38,6.38,0,0,1,390,75.49a7.24,7.24,0,0,1-3.28,6.24q-3.27,2.3-9.08,2.3A23.09,23.09,0,0,1,370.64,83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.63,16.34H36.7c-15.22,0-27.56,12-27.56,26.7V89.57c0,14.74,12.34,26.7,27.56,26.7a15.67,15.67,0,0,1,3.57.41c3.84,1.71,2,15.95,5.13,17.75a1.19,1.19,0,0,0,1.36-.13c2.47-2.1,14.47-17.56,19.5-17.76,3.57-.14,31.34,0,31.34,0,15.22,0,27.59-12.23,27.59-27V43C125.19,28.3,112.85,16.34,97.63,16.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.3,39.56l-23.05-35a9.28,9.28,0,0,0-8-4.58H29.6a7.54,7.54,0,0,0-6.53,3.8L0,39.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0,39.4s0,.09,0,.13c0,9.76,7.65,17.68,17.09,17.68s17.09-7.92,17.09-17.68V39.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.34,39.4s0,.09,0,.13c0,9.76,7.65,17.68,17.09,17.68s17.09-7.92,17.09-17.68V39.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M68.52,39.4s0,.09,0,.13c0,9.76,7.58,17.68,16.93,17.68s16.92-7.92,16.92-17.68V39.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M102.37,39.4s0,.09,0,.13c0,9.76,7.6,17.68,17,17.68s17-7.92,17-17.68c0,0,0-.09,0-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M67.93,87.28c-8.38,0-16.11-.72-22.39-5.78-.83-.67-1.71.82-1.09,1.87,5.37,9.1,13.68,15.81,22.94,15.81,9.49,0,17.86-6.74,23.19-16.43.31-.56,0-2.07-.47-1.73C83.89,85.93,76.16,87.28,67.93,87.28Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalFullBrand);
export default __webpack_public_path__ + "static/media/horizontal_full-brand.30e99b8aefd2483cd6aea902e3a30590.svg";
export { ForwardRef as ReactComponent };